import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke115aRequest, Sgke115aResponse, Sgke115aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke115aService {

  /**
   * コンストラクタ
   * @param {Sgke115aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke115aService
   */
  constructor(
    public service: Sgke115aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * Sgke115aAPI実行
   *
   * @param {Sgke115aRequest} request
   * @return {*}  {Observable<Sgke115aResponse>}
   * @memberof UsedSgke115aService
   */
  public doSgke115a(request: Sgke115aRequest): Observable<Sgke115aResponse> {

    return this.service.sgke115aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE115A');
          return throwError(err.message);
        })
      );
  }

}

